import React from "react";
import "./Namee.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Namee8images from "../../../Media/BSD/Eonna/Namee8";
import Namee9images from "../../../Media/BSD/Eonna/Namee9";

const imageMap = {
  Namee8images,
  Namee9images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Namee" className="Wynyard">
      <h1>Welcome to Namee</h1>
      <h2>Cicilan Start 22 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
